import {
    CloseIcon,
    CheckmarkIcon,
    WarningIcon,
} from '@design-systems/react-icons'
import { isGreenish, isReddish, isYellowish } from './color-helper'

/**
 *
 * @param color 3 or 6 character hex code, with out without hash
 * @returns
 */
export const adaptStatusColorToClass = (color: string): string => {
    switch (true) {
        case isReddish(color):
            return 'hc-clr-error'
        case isGreenish(color):
            return 'hc-clr-success'
        case isYellowish(color):
            return 'hc-clr-attention'
        default:
            return ''
    }
}

/**
 *
 * @param color 3 or 6 character hex code, with out without hash
 * @returns
 */
export const adaptStatusColorToIcon = (
    color: string,
): React.FunctionComponent<null> | undefined => {
    switch (true) {
        case isReddish(color):
            return CloseIcon
        case isGreenish(color):
            return CheckmarkIcon
        case isYellowish(color):
            return WarningIcon
        default:
            return
    }
}
